import type { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

export type MainPageTitleProps = HTMLAttributes<HTMLHeadingElement>;
export const MainPageTitle = ({
  children,
  className,
  ...props
}: MainPageTitleProps) => {
  return (
    <h1
      className={cn(
        'mb-2 font-semibold text-3xl text-white leading-12',
        className
      )}
      {...props}
    >
      {children}
    </h1>
  );
};
